<script>
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import { sortById, groupSort } from '../utils/Sort.svelte';
  import { warning, locate, move, sync, trash, cut, checkmark, close, compass } from 'ionicons/icons/index.mjs';

    export let location;
    export let config;
    export let map;
    export let isDrawing;
    export let isMeasuring;
    export let selectedLayer;
    export let selectedFeature;
    let locationLineOn = false;
    let selectedType = "measure";
    console.log(config)
    console.log(selectedLayer)

    const dispatch = createEventDispatcher();
    function sendMessage(message) {
        dispatch('message', message);
    }

    function drawHandler(e) {
		  e.currentTarget.blur();
      if (selectedType == "measure") {
         sendMessage({
            type: "measure"
        })
      }
      else {
        sendMessage({
            type: "draw",
            data: {
                type: selectedType
            }
        })
      }
    }

    function geometryHandler(e) {
		  e.currentTarget.blur();
      sendMessage({
          type: "geometry",
          data: {
                type: "edit"
            }
      })
    }

    function locationHandler(e) {
		  e.currentTarget.blur();
      sendMessage({
          type: "geometry",
          data: {
                type: "location"
            }
      })
    }

    function locationLineHandler(e) {
		  e.currentTarget.blur();
      locationLineOn = !locationLineOn;
      sendMessage({
          type: "location-line"
      })
    }

    function deleteHandler(e) {
		  e.currentTarget.blur();
      sendMessage({
          type: "delete",
      })
    }
</script>

<div in:fade>
    <div class="tile tile-centered pl-2 pr-2">
        <div class="tile-content">
            <div class="divider" data-content="DRAW FEATURE"></div>
        </div>
    </div>
    <div class="pl-2 pr-2">
      <div class="form-group pb-1">
        <select id="layerList" class="form-select" bind:value={selectedType}>
            <option value="measure">Measure</option>
            <option selected value="draw_point">Draw Point</option>
            <option selected value="draw_line_string">Draw Line</option>
            <option selected value="draw_polygon">Draw Polygon</option>
        </select>
      </div>
      {#if isDrawing || isMeasuring}
         <button class="btn btn-primary mt-2 mb-2" style="width:100%;" on:click={drawHandler}><div class="tile tile-centered">
                  <div class="tile-content">
                    Stop
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html close.md}</i>
                  </div>
              </div></button>
      {:else}
        <button class="btn btn-primary mt-2 mb-2" style="width:100%;" on:click={drawHandler}>
        <div class="tile tile-centered">
                  <div class="tile-content">
                    Start
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html checkmark.md}</i>
                  </div>
              </div>
        </button>
      {/if}
      {#if config.role > 2 && !isDrawing && !isMeasuring && selectedLayer && selectedLayer.id != "__draw" && selectedLayer.id != "scenes"}
        <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Edit Geometry" on:click={geometryHandler}><div class="tile tile-centered">
                  <div class="tile-content">
                    Edit Geometry
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html move.md}</i>
                  </div>
              </div></button>
        <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Delete Feature" on:click={deleteHandler}><div class="tile tile-centered">
                  <div class="tile-content">
                    Delete Feature
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html trash.md}</i>
                  </div>
              </div></button>
      {/if}
      {#if config.role > 2 && !isDrawing && !isMeasuring && selectedLayer && selectedLayer.id != "__draw" && selectedLayer.id != "scenes" && location.enabled && selectedFeature && selectedFeature.geometry.type == "Point"}
        <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Move Feature to Current Location" on:click={locationHandler}><div class="tile tile-centered">
                  <div class="tile-content">
                    Move Feature to Location
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html locate.md}</i>
                  </div>
              </div></button>
      {/if}
      {#if config.role > 2 && !isDrawing && !isMeasuring && location.enabled && !locationLineOn}
        <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Draw Line with Location" on:click={locationLineHandler}><div class="tile tile-centered">
                  <div class="tile-content">
                    Draw Line with Location
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html compass.md}</i>
                  </div>
              </div></button>
      {/if}
      {#if config.role > 2 && !isDrawing && !isMeasuring && location.enabled && locationLineOn}
        <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Stop Line with Location" on:click={locationLineHandler}><div class="tile tile-centered">
                  <div class="tile-content">
                    Stop Line with Location
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html compass.md}</i>
                  </div>
              </div></button>
      {/if}
      {#if !isMeasuring && !isDrawing}
          <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Clear Snap Layer" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
                sendMessage({
                    type: "clear",
                    data: {
                      type: "snaps"
                    }
                })
              }}>
              <div class="tile tile-centered">
                  <div class="tile-content">
                    Clear Snap Layer
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html sync.md}</i>
                  </div>
              </div>
            </button>
        {/if}
    {#if !isMeasuring && !isDrawing}
          <button class="btn btn-primary mt-2 mb-2" style="width:100%;" data-tooltip="Clear All" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
                sendMessage({
                    type: "clear"
                })
              }}>
              <div class="tile tile-centered">
                  <div class="tile-content">
                    Clear All
                  </div>
                  <div class="tile-action">
                    <i class="svg svg-light">{@html cut.md}</i>
                  </div>
              </div>
            </button>
        {/if}
    </div>
</div>

<style>
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .empty .empty-icon {
        width: 150px;
        margin: auto;
    }
    .empty .empty-title {
        margin-top: 0;
        color: black;
    }
</style>